import React, { useContext, useEffect, useState } from 'react'
import Button from '../components/button'
import Top from '../components/top'
import Table from '../components/table'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'
import { DetailsContext } from '../contexts/DetailsContext'

const Payment = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {
      user,
      setUser,
      isLogged,
      setIsLogged,
      login,
      logout
    } = useContext(AuthContext)

    const { banks } = useContext(DetailsContext)
    
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])

    const inputs = [
        {
          name: "name",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Name',
        },
        {
          name: "account",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Account'
        }
      ]

    props.setNavShow(true)
    function formatNumber(number) {
      return number.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
      });
  }
    const userColumns = ['Gateway ID', 'Name', 'Account']
    function addUsers(){
        window.location.replace('/edit')
    }
    const link = 'https://xgramm.com/xgramm_backend/admin/banks.php'
  return (
    <div  style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={true} value='Add New Bank' name='Banks'/>
        <div className="w3-container">
        <Table tableName='banks' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='Bank Gateway' columns={userColumns} data={banks ? banks : []} summary={false} edit={true} />
        </div>
    </div>
  )
}

export default Payment